import React from "react";
import { Grid, Typography, Box } from "@mui/material";

const AssistanceSection = () => {
  // Dynamic data
  const contactInfo = {
    email: "support@pixell.in",
    number: "+91 9812731231",
    assistanceHours: "Monday - Friday 6 am to 8 pm EST",
  };

  return (
   
    <Box
      sx={{
        width: "100%",
        padding: "4.9rem 2rem ",
        backgroundImage: `url(/assests/images/LandingPage/ContactUs/ContactUsBackImage.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="xl:max-w-7xl mx-auto">
      <Grid
        container
        spacing={4}

      >
        {/* Left Section: Heading */}

        <Grid item sm={12} md={4} lg={6} >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              // textAlign: { xs: "left" },
              marginBottom: { xs: "2rem", md: "0rem", lg: "2.2rem" },
              marginLeft: { xs: "0rem", sm: "8rem", md: "4rem" }, // Responsive margin-left
              maxWidth: "454px",
              fontSize: { xs: "25px", md: "35px" },
            }}
          >
            We are always happy to assist you
          </Typography>
        </Grid>

        {/* Right Section: Contact Information */}


 {/* Number Section */}
 <Grid item sm={6} md={4} lg={3}>
          <Typography className="text-[var(--all-black-color)]"
            variant="subtitle1"
            sx={{
              fontWeight: "600",
              fontSize: "20px",
              marginBottom: "0.5rem",
              marginLeft: { xs: "0rem", sm: "5rem", md: "0rem" },

            }}
          >
            Contact Details
          </Typography>
          <Typography className="text-[var(--all-black-color)]"
            variant="body1"
            sx={{

              fontSize: "20px",
              fontWeight: "400",
              marginLeft: { xs: "0rem", sm: "5rem", md: "0rem" },

            }}
          >
            +91 9220605735
          </Typography>
          <Typography className="text-[var(--all-black-color)]"
            variant="body2"
            sx={{
              marginTop: "0.5rem",
              fontSize: "14px",
              fontWeight: "300",
              marginLeft: { xs: "0rem", sm: "5rem", md: "0rem" },
            }}
          >
            Assistance hours: <br />
            Monday - Friday 10 am to 8 pm IST
          </Typography>
          <Typography className="text-[var(--all-black-color)]"
            variant="body2"
            sx={{
              marginTop: "0.5rem",
              fontSize: "14px",
              fontWeight: "300",
              marginLeft: { xs: "0rem", sm: "5rem", md: "0rem" },
            }}
          >
            Address: <br />
           Shop no. 9,  New Tikona Park, N.I.T, Faridabad, Haryana -121001
          </Typography>
        </Grid>
        
        {/* Email Section */}
        <Grid item sm={6} md={4} lg={3}>
          <Typography
            variant="subtitle1"
            sx={{
              marginLeft: { xs: "0rem", sm: "7rem", md: "0rem" },
              fontWeight: "600",
              fontSize: "20px",
              marginBottom: "0.5rem",
            }}
          >
            Email Address
          </Typography>

          <Typography className="text-[var(--all-black-color)] "

            variant="body1"
            sx={{
              marginLeft: { xs: "0rem", sm: "7rem", md: "0rem" },
              fontSize: "20px",
              fontWeight: "400",
            }}
          >
            support@pixell.in
          </Typography>
          <Typography className="text-[var(--all-black-color)]"
            variant="body2"
            sx={{
              marginLeft: { xs: "0rem", sm: "7rem", md: "0rem" },
              marginTop: "0.5rem",
              fontSize: "14px",
              fontWeight: "400",
            }}
          >
            Assistance hours: <br />
            Monday - Friday 10 am to 8 pm IST
          </Typography>
        </Grid>

       

        


      </Grid>
      </div>
    </Box>
  );
};

export default AssistanceSection;
